import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Card, CardContent } from '../components/ui/card';
import { LayoutDashboard, ClipboardList, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

export default function AppSelectorPage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="w-full max-w-2xl space-y-8">
        {/* Header */}
        <div className="text-center space-y-2">
          <img
            src="/stp-logo.png"
            alt="Stellar"
            className="h-12 mx-auto mb-4"
          />
          <h1 className="text-2xl font-display font-semibold tracking-tight">
            Welcome back, {user?.name?.split(' ')[0] || 'there'}
          </h1>
          <p className="text-sm text-muted-foreground">Choose your workspace</p>
        </div>

        {/* Tool Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {/* Social Media CRM */}
          <motion.button whileHover={{ y: -4, boxShadow: '0 20px 40px rgba(0,0,0,0.15)' }} whileTap={{ scale: 0.98 }} transition={{ duration: 0.2 }}
            onClick={() => {
              localStorage.setItem('stellar_active_tool', 'crm');
              navigate('/crm');
            }}
            className="text-left group"
            data-testid="select-crm-tool"
          >
            <Card className="bg-card/60 backdrop-blur border-2 border-transparent hover:border-primary/40 transition-all h-full group-hover:shadow-lg">
              <CardContent className="p-6 space-y-4">
                <div className="h-12 w-12 rounded-xl bg-primary/10 flex items-center justify-center">
                  <LayoutDashboard className="h-6 w-6 text-primary" />
                </div>
                <div>
                  <h2 className="text-lg font-display font-semibold">Social Media CRM</h2>
                  <p className="text-xs text-muted-foreground mt-1">
                    Content calendar, post composer, client approvals, analytics, and publishing
                  </p>
                </div>
                <div className="flex items-center text-xs text-primary font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                  Open <ArrowRight className="h-3 w-3 ml-1" />
                </div>
              </CardContent>
            </Card>
          </motion.button>

          {/* Task Manager */}
          <motion.button whileHover={{ y: -4, boxShadow: '0 20px 40px rgba(0,0,0,0.15)' }} whileTap={{ scale: 0.98 }} transition={{ duration: 0.2 }}
            onClick={() => {
              localStorage.setItem('stellar_active_tool', 'tasks');
              navigate('/tasks');
            }}
            className="text-left group"
            data-testid="select-tasks-tool"
          >
            <Card className="bg-card/60 backdrop-blur border-2 border-transparent hover:border-cyan-400/40 transition-all h-full group-hover:shadow-lg">
              <CardContent className="p-6 space-y-4">
                <div className="h-12 w-12 rounded-xl bg-cyan-500/10 flex items-center justify-center">
                  <ClipboardList className="h-6 w-6 text-cyan-400" />
                </div>
                <div>
                  <h2 className="text-lg font-display font-semibold">Task Manager</h2>
                  <p className="text-xs text-muted-foreground mt-1">
                    Team tasks, assignments, time tracking, calendar, priorities, and AI assistance
                  </p>
                </div>
                <div className="flex items-center text-xs text-cyan-400 font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                  Open <ArrowRight className="h-3 w-3 ml-1" />
                </div>
              </CardContent>
            </Card>
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
}
